import React from 'react';

interface BackArrowIconProps {
  size?: number;
  color?: string;
}

export const BackArrowIcon: React.FC<BackArrowIconProps> = ({ 
  size = 16, 
  color = '#fff' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      fill="none" 
      viewBox="0 0 16 16"
    >
      <path 
        fill={color} 
        d="M10 14.666 5 8l5-6.667.887 1.183L6.775 8l4.112 5.483z"
      />
    </svg>
  );
};

